// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"117":"fffde0d1","150":"a1d62c50","174":"ef3055c7","310":"fd1d1343","351":"d39cb234","371":"738be175","559":"4f80f9e7","626":"c3a6961e","819":"3e84a9e3","853":"addcbf6a"}[chunkId] + ".chunk.js";
};